import React, { useState } from 'react';
import styles from './pay-liked-item.module.scss';
import { ButtonsLikeDislikeCard } from '../buttons-like-dislike-card';
import { VoteProfileDto } from '@/api/profiles';
import { Avatar, BottomSheet, Button, Typography } from '@/ui-kit';
import { PayedLike } from '@/types/profile';
import { differenceInYearsResult } from '@/utils/difference-in-years-result';
import { PremiumIcon, VerifiedAccountIcon } from '@/assets/icons';
import { routesApp } from '@/constans/routes';
import { generatePath, useNavigate } from 'react-router-dom';
import WebApp from '@twa-dev/sdk';
import { useVibration } from '@/store/useVibration';
import { PremiumBottomsheet } from '@/components/premium-bottomsheet';
import { getDisplayLikeCreatedDate, getProfileNameAndAge } from '@/utils/msgs';

interface Props {
    img?: string | null;
    like: PayedLike;
    onVoteProfile?: (vote: VoteProfileDto['value']) => void;
}

export const PayLikedItem: React.FC<Props> = ({ like, onVoteProfile }) => {
    const navigate = useNavigate();

    const { isVibrationEnabled } =
        useVibration(state => state);
    
    const handleVoteProfile = (vote: VoteProfileDto['value']) => {
        if (onVoteProfile) {
            onVoteProfile(vote);
            if (isVibrationEnabled) {
                WebApp
                    .HapticFeedback
                    .impactOccurred('medium');
                // pass for not android
                navigator.vibrate?.(10)
            }
        }
    };

    const handleClick = () => {
        const path = generatePath(routesApp.profileView, { id: String(like?.profile?.id) });
        navigate(path);
        if (isVibrationEnabled) {
            WebApp
                .HapticFeedback
                .impactOccurred('medium');
            // pass for not android
            navigator.vibrate?.(10)
        }
    };

    const [isVerificationModalOpen, setIsVerificationModalOpen] =
        useState(false);

    const [isPremiumModalOpen, setIsPremiumModalOpen] =
        useState(false);
    
    const likeProfileGnder =
        like?.profile?.gender

    const subtitle =
        [
            ...(
                likeProfileGnder === 'female' ?
                    ['Лайкнула']
                : likeProfileGnder === 'male' ?
                    ['Лайкнул']
                : []
            ),
            ...(
                like?.created_at ?
                    [
                        getDisplayLikeCreatedDate(like.created_at)
                    ]
                :
                    []
            )
        ]
            .join(' ')

    return (
        <>
            <div
                className={styles.avatar}
                onClick={handleClick}>
                <Avatar
                    size={64}
                    src={like?.profile?.photos.length ? like?.profile?.photos[0]?.thumb_url : null}
                    alt={like?.profile?.public_name ?? 'avatar'}
                    borderRadius="22px" />

                {like?.profile?.is_online && <span className={styles.status}></span>}
            </div>
            <div
                className={styles.wrapInfo}
                onClick={handleClick}>
                <div className={styles.info}>
                    <div className={styles.nameAndVerificationStatusInfo}>
                        <Typography
                            typeColor="black"
                            className={styles.name}>
                            <span>
                                {' '}
                                {getProfileNameAndAge(like?.profile)}
                            </span>
                        </Typography>
                        {
                            like
                                ?.profile
                                ?.verification_status
                                === 'verified' &&
                            <VerifiedAccountIcon
                                width={20}
                                height={20}
                                className={styles.verificationStatusInfo}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    setIsVerificationModalOpen(true)
                                }} />
                        }
                        {
                            like
                                ?.profile
                                ?.is_paid &&
                            <PremiumIcon
                                width={20}
                                height={20}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    setIsPremiumModalOpen(true)
                                }} />
                        }
                    </div>
                    {
                        subtitle.length &&
                        <Typography typeColor="black" className={styles.time}>
                            {
                                subtitle
                            }
                        </Typography>
                    }
                </div>
            </div>
            <ButtonsLikeDislikeCard
                onClickDislike={() => handleVoteProfile(false)}
                onClickLike={() => handleVoteProfile(true)} />
            <BottomSheet
                overlayClassName={styles.bottomsheetOverlay}
                isOpen={isVerificationModalOpen}
                isDeskorTop={false}
                onClose={() => setIsVerificationModalOpen(false)}>
                <div className={styles.verificationModalContent}>
                    <div className={styles.verificationModalContentIcon}>
                        <Avatar
                            src={
                                like
                                    ?.profile
                                    ?.photos
                                    .length ?
                                        like
                                            ?.profile
                                            ?.photos[0]
                                            .main_url
                                    :
                                        null
                            }
                            size={96} />
                        <VerifiedAccountIcon
                            className={styles.verificationModalContentIconVerification}
                            width={28}
                            height={28} />
                    </div>
                    <div className={styles.verificationModalContentHeader}>
                        <Typography
                            className={styles.verificationModalContentHeaderTitle}
                            variant={'h5'}
                            fontWeight={'bold'}>
                            {
                                [
                                    like
                                        ?.profile
                                        .public_name,
                                    like
                                        ?.profile
                                        .gender === 'male' ?
                                        'прошёл'
                                    :
                                        'прошла',
                                    'проверку',
                                ].join(' ')
                            }
                        </Typography>
                        <Typography
                            className={styles.verificationModalContentHeaderDesc}>
                            Видео-верификация подтверждает, что за анкетой стоит реальный человек и что фото принадлежат ему. Это помогает сделать общение честнее и безопаснее.
                        </Typography>
                    </div>
                    <div className={styles.verificationModalContentFootnote}>
                        <Button
                            typeColor="orange"
                            className={styles.verificationModalContentFootnoteBtn}
                            onClick={() => setIsVerificationModalOpen(false)}>
                            Понятно!
                        </Button>
                    </div>
                </div>
            </BottomSheet>
            <PremiumBottomsheet
                photo={like.profile.photos.length ? like.profile.photos[0].main_url : null}
                name={like.profile.public_name}
                isPremiumModalOpen={isPremiumModalOpen}
                setIsPremiumModalOpen={setIsPremiumModalOpen} />
        </>
    );
};
